import { render, staticRenderFns } from "./Mostplays.vue?vue&type=template&id=365797c0"
import script from "./Mostplays.vue?vue&type=script&lang=js"
export * from "./Mostplays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports